import { render, staticRenderFns } from "./boxLabelDatas.vue?vue&type=template&id=50d58554&scoped=true&"
import script from "./boxLabelDatas.vue?vue&type=script&lang=js&"
export * from "./boxLabelDatas.vue?vue&type=script&lang=js&"
import style0 from "./boxLabelDatas.vue?vue&type=style&index=0&id=50d58554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d58554",
  null
  
)

component.options.__file = "boxLabelDatas.vue"
export default component.exports